<template>
        <div class="row">
            <div>
                {{ $t('common.Keeper_dashboard') }}
            </div>
            <div class="col-lg-8">
                <!--div class="row">
                    <div class="col-lg-10">
                        <div style="width: 50%; float: left; ">
                            <input v-model="searchText" type="text" class="form-control"
                                style="border:1px solid #d2d6da; padding: .375rem .75rem;" :placeholder="$t('common.Search') + '...'" @keydown="searchBoxKeyDown">
                        </div>
                        <div style="float:left; margin-left:10px;">
                            <button v-on:click="searchUserActions" class="btn bg-gradient-success">{{ $t('common.Search') }}</button>
                        </div>
                    </div>
                </div-->
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-8">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('location.Locations') }}
                            </h6>
                        </div>
                        <div class="col-lg-4">                            
                        </div>
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table id="location-list" class="table table-flush">
                                <tbody>
                                    <tr v-for="location in locations" v-bind:key="location.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ location.ubn }}{{ location.name ? ' (' + location.name + ')' : '' }}<br />
                                            <span class="mb-0 text-xs font-weight-bold">{{ $t('location.Animals') }}: </span>
                                            <i class="material-symbols-rounded opacity-10 font-size-12" 
                                                :class="location.hasAnimals ? 'text-success' : 'text-danger'"
                                                aria-hidden="true">
                                                {{ location.hasAnimals ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                            <br />
                                            <span class="mb-0 text-xs font-weight-bold">{{ $t('location.Active_animals') }}: 
                                                {{ location.animalCount }}
                                            </span>
                                            <!--br />
                                            <span class="mb-0 text-xs font-weight-bold">{{ $t('location.ToilerDiseaseFree') }}: 
                                                <i class="material-symbols-rounded opacity-10 font-size-12" 
                                                    :class="location.isToilerDiseaseFree ? 'text-success' : 'text-danger'"
                                                    aria-hidden="true">
                                                    {{ location.isToilerDiseaseFree ? 'thumb_up' : 'thumb_down' }}
                                                </i>
                                            </span>
                                            <br />
                                            <span class="mb-0 text-xs font-weight-bold">{{ $t('location.ScrapieCertificate') }}: 
                                                <i class="material-symbols-rounded opacity-10 font-size-12" 
                                                    :class="location.hasScrapieCertificate ? 'text-success' : 'text-danger'"
                                                    aria-hidden="true">
                                                    {{ location.hasScrapieCertificate ? 'thumb_up' : 'thumb_down' }}
                                                </i>
                                            </span-->
                                            <br />
                                            <span class="mb-0 text-xs font-weight-bold">{{ $t('location.RVO') }}: 
                                                <i class="material-symbols-rounded opacity-10 font-size-12" 
                                                    :class="location.isRvoVerified ? 'text-success' : 'text-danger'" 
                                                    aria-hidden="true">
                                                    {{ location.isRvoVerified ? 'thumb_up' : 'thumb_down' }}
                                                </i>
                                            </span>
                                        </td>
                                        <td class="text-sm font-weight-normal" v-html="location.locationFullAddress"></td>
                                        <td v-show="locations.length > 1 && location.id !== $store.state.keeperLocationId">
                                            <div class="float-end">
                                                <button :data-id="location.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 preview-button" style="margin-right: 10px !important;" @click="selectLocation(location.id, location.associationId, location.ubn)" :title="$t('common.Select_location')">
                                                    <i class="material-symbols-rounded text-white" style="font-size: 1.4rem;" aria-hidden="true">gesture_select</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card mb-4" v-if="keeperLocation">
                    <h6 class="ms-3 mt-3 mb-2">{{ $t('dashboard.Active_location') }}</h6>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <ul class="dashboard-log list-unstyled row">
                            <li class="col-md-12 text-sm">                                
                                <span style="color: #337ab7;">
                                    {{ keeperLocation.ubn }}{{ keeperLocation.name ? ' (' + keeperLocation.name + ')' : '' }}
                                </span>
                                <br />
                                <span v-html="keeperLocation.locationFullAddress"></span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="card mb-4">
                    <h6 class="ms-3 mt-3 mb-2">{{ $t('dashboard.Notifications') }}</h6>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <!--What to display here
                        ul class="dashboard-log list-unstyled row">
                            <li class="col-md-12 text-sm">
                                {{ $t('dashboard.Last_login') }}:
                                <span style="color: #337ab7;">
                                    {{ formatDate(userLoginLog.dateTimeStamp) }}
                                </span>
                            </li>
                        </ul>
                        <p class="text-danger small" v-if="!userLoginLog.id">{{ $t('dashboard.No_activity_logged') }}</p-->
                    </div>
                </div>
                <div class="card mb-4">
                    <h6 class="ms-3 mt-3 mb-2">{{ $t('dashboard.User_manual') }}</h6>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <ul class="dashboard-log list-unstyled row">
                            <li class="col-md-12 text-sm">
                                <a :href="userManualUrl" download class="download-link text-success d-inline-flex align-items-center">
                                    <i class="material-symbols-rounded me-1">download</i>
                                    <span class="underline-text">{{ $t('dashboard.Download_user_manual') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--
                <div class="card mb-4">
                    <h6 class="ms-3 mt-3 mb-2">{{ $t('dashboard.Login_log') }}</h6>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <ul class="dashboard-log list-unstyled row">
                            <li class="col-md-12 text-sm">
                                {{ $t('dashboard.Last_login') }}:
                                <span style="color: #337ab7;">
                                    {{ formatDate(userLoginLog.dateTimeStamp) }}
                                </span>
                            </li>
                        </ul>
                        <p class="text-danger small" v-if="!userLoginLog.id">{{ $t('dashboard.No_activity_logged') }}</p>
                    </div>
                </div>                
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-8">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('dashboard.User_actions') }} <br /><span class="dashboardNoOfRecords">({{ $t('dashboard.No_of_user_actions_found') }}{{ userActions.length }})</span>
                            </h6>
                        </div>
                        <div class="col-lg-4">                            
                        </div>
                    </div>                    
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container" :style="[userActions.length > 3 ? 'height: 300px' : '']">
                            <table class="table align-items-center">                                
                                <tbody>
                                    <tr v-for="userAction in userActions" v-bind:key="userAction.id"> 
                                        <td>
                                            <i class="fas fa-desktop text-lg opacity-6" v-if="userAction.deviceType === 'Desktop'"></i>
                                            <i class="fas fa-mobile text-lg opacity-6" v-else></i>
                                        </td>
                                        <td class="text-sm">
                                            <span class="dashboardNoOfRecords">{{ formatDate(userAction.dateTimeStamp) }}<br /></span>
                                            <span class="dashboardNoOfRecords"><b>{{ $t('dashboard.User_agent_host') }}: </b>
                                            {{ userAction.userAgent }} <br> 
                                            {{ userAction.userHostIp }}</span>
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>
                    </div>                    
                </div>
                -->
            </div>
        </div>
</template>

<script>
import axios from 'axios'
import { nextTick } from 'vue';

export default {
    name: 'Dashboard_page',
    components: {        
    },
    data() {
        return {
            userManualUrl: "/usermanuals/Handleiding_Houders_Fokkers_v01.pdf",
            searchText: '',
            locations: [],
            userActions: [],
            loginlogs: [],
            gets: [],            
            userLoginLog: []
        }
    },
    computed: {   
        userRoleName() {
            return this.$store.state.user?.roleName;
        },        
        keeperLocation() {
            return this.locations.find((location) => location.id === this.$store.state.keeperLocationId);
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);
            
            //console.log(this.$store.state.user.id);

            const response = await axios.get("Dashboard/getallkeeper/");
            this.gets = response.data;

            if (this.gets.success) {                
                this.userLoginLog = this.gets.data['lastUserLoginLog'];
                this.userActions = this.gets.data['lstUserLoginLog'];

                await nextTick();
                await this.fetchAllLocationData(this.$store.state.user.id);

            } else {
                this.$showError('errors.Contact_system_admin');                
            }

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }        
    },
    methods: {

        selectLocation(locationId, associationId, ubn) {
            // Save to sessionStorage
            sessionStorage.setItem('keeperLocationId', locationId);
            sessionStorage.setItem('keeperAssociationId', associationId);            
            sessionStorage.setItem('keeperUBN', ubn);

            // Also commit to Vuex so it's available reactively
            this.$store.commit('setKeeperLocationId', locationId);
            this.$store.commit('setKeeperAssociationId', associationId);
            this.$store.commit('setKeeperUBN', ubn);
        },
        searchBoxKeyDown() {
            //console.log('Key pressed:', event.key);
        },
        formatDate(dateTimeStamp) {
            return new Date(dateTimeStamp).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        }, 
        async fetchAllLocationData(aspNetUserId) {
            try {
                const response = await axios.get("Location/getall?id=" + aspNetUserId);
                this.gets = response.data;

                if (this.gets.success) {                   
                    if(this.gets.data != null) {
                        this.locations = this.gets.data.locationList;

                        if (this.locations.length === 1) { 
                            const locId = this.locations[0].id;
                            const ubn = this.locations[0].ubn;
                            const assocId = this.locations[0].associationId;
                            const assocWebsiteURL = this.locations[0].associationWebsiteURL;

                            // Save to sessionStorage
                            sessionStorage.setItem('keeperLocationId', locId);
                            sessionStorage.setItem('keeperAssociationId', assocId);
                            sessionStorage.setItem('keeperUBN', ubn);
                            sessionStorage.setItem('associationWebsiteURL', assocWebsiteURL);

                            // Also commit to Vuex so it's available reactively
                            this.$store.commit('setKeeperLocationId', locId);
                            this.$store.commit('setKeeperAssociationId', assocId);
                            this.$store.commit('setAssociationWebsiteURL', assocWebsiteURL);
                            this.$store.commit('setKeeperUBN', ubn);
                        }
                    }
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async searchUserActions() {
            try {
                this.$store.commit('setShowLoading', true);
                if (this.searchText != '') {
                    const response = await axios.get("Dashboard/getallkeeperbysearch?search=" + this.searchText);
                    this.gets = response.data;
                } else {
                    this.$showError('errors.Search_text_is_not_specified');                        
                }

                if (this.gets.success) {  
                    this.userLoginLog = this.gets.data['lastUserLoginLog'];
                    this.userActions = this.gets.data['lstUserLoginLog'];
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
            this.$store.commit('setShowLoading', false);
        },                
    }
}
</script>

<style scoped>
.table td,
.table th {
    white-space: normal !important;
}
</style>

<style scoped>
    .download-link i {
        vertical-align: middle;
        margin-right: 4px;
    }
    .download-link span {
        vertical-align: middle;
    }
    .table-container {
        width: 100%;
        margin: 0 auto;
        position: relative;
        /* height: 300px; */
        overflow: auto;
    }

    /* Style table */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 1em;
    }

    thead {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    thead td {
        background-color: #fff;         
        /* padding: 1rem 0.5rem;       */  
        border-bottom: 2px solid #ddd;
    }

    .well-header3 {
        font-size: 22px;
        margin: 0 0 0 -8px;
        padding-left: 10px;
        border-left: 10px solid;
        border-color: #586ca5;
    }

    .dashboardNoOfRecords {
        font-size: 12px;
    }
    .dashboardNoOfRecords {
        font-size: 12px;
        font-weight: normal;
    }

    .font-size-12 {
        font-size: 12px !important;
    }
</style>